// ABOUTME: Resolves runtime feature flags (dev / simulate) from the page URL + host.
// ABOUTME: One testable place for the gating that unlocks unlimited plants + load sims.

// Resolve which testing behaviours are unlocked for this page load.
//
// - `devMode`   — `?dev` or a localhost host. Bypasses the session plant limit and
//   uses the short (seconds-long) fresh-pole glow window for observing the fade.
// - `simulateMode` — `?simulate`. Meant for the public demo build (hopp-demo.pages.dev):
//   it lifts the plant limit and enables the ?simulatePennants load simulation, but
//   is NOT dev mode, so the production 30-minute glow window and polish stay intact.
// - `unlimitedPlants` — the once-per-session plant limit is lifted.
// - `simulationEnabled` — the ?simulatePennants URL load simulation may run. Normally
//   this only ran under the Vite dev server; simulate mode opts a production build in.
export function resolveRuntimeMode(search = '', { hostname = '' } = {}) {
    const params = new URLSearchParams(search ?? '');
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const devMode = params.has('dev') || isLocalhost;
    const simulateMode = params.has('simulate');
    return {
        devMode,
        simulateMode,
        unlimitedPlants: devMode || simulateMode,
        simulationEnabled: devMode || simulateMode,
    };
}
